<template>
  <div class="top-bar">
    <!-- Left side -->
    <div class="top-bar__left">

      <!-- Brand -->
      <div class="top-bar__brand">
        <a 
          id="hamburger-icon" 
          v-if="isLoggedIn" 
          href="#" title="Menu" 
          :class="{'active': sidebarState }" 
          @click="openSidebar" 
        >
          <span class="line line-1"></span>
          <span class="line line-2"></span>
          <span class="line line-3"></span>
        </a>
        <a 
          id="hamburger-icon" 
          v-else 
          href="#" title="Menu" 
          class="sidebar__log-out"
          :class="{'active': sidebarState }" 
          @click="openSidebar" 
        >
          <span class="line line-1"></span>
          <span class="line line-2"></span>
          <span class="line line-3"></span>
        </a>
        <div v-if="mpCustomLogo">
          <img height="27" :src="mpCustomLogo"/>
        </div>
        <div v-else-if="logoUrl">
          <a :href=" isRestel ? 'https://www.restel.fi/': (lang + '/')"><img :src="logoUrl" alt=""></a>
        </div>
        <div v-else style="margin-top:15px;">
          <span class="venue_name_logo">{{ venueInfo.title}}</span>
        </div>

      </div>

      <MPSearchbar v-if="!isHotelWl" :class="{'show-mobile': sidebarState, 'hide-mobile': !sidebarState }" />
      <!-- Language selection -->
      <MPLanguage v-if="!hideLogin" :class="{'show-mobile': sidebarState, 'hide-mobile': !sidebarState  }"/>
    </div>

    <!-- Right side -->
    <nav class="top-bar__right top-bar__right--hidden-mobile" v-if="!isLoggedIn">
      <ul class="nav"  v-if="!hideLogin">
        <li class="nav__item"><a :href="lang + '/user/login'" class="nav__link">{{ strings.login }}</a></li>
        <li v-if="!isHotelWl" class="nav__item"><a :href="lang + '/user/register'" class="nav__link">{{ strings.register }}</a></li>
        <li class="nav__item"><a href="/venue-self-register" class="nav__link nav__link--button">{{ strings.listyourvenue }}</a></li>
      </ul>
    </nav>

    <nav class="top-bar__right top-bar__right--hidden-mobile" v-else>
      <ul class="nav">
        <li class="nav__item"><a :href="lang + '/dashboard'" class="nav__link">{{ userName }}</a></li>
        <li class="nav__item"><a :href="lang + '/user/logout'" class="nav__link">{{ strings.logout }}</a></li>
      </ul>
    </nav>
  </div>
</template>
<script>
import MPSearchbar from './Searchbar.vue';
import MPLanguage from './Language.vue';

export default {
  name: 'MPHeader',
  data() {
    return {
      isOpen: false,
      hideLogin: window.location.hostname == 'hansel.meetingpackage.com',
      isRestel: window.location.hostname == 'restel.meetingpackage.com',
      isHotelWl: window.isHotelWl,
      logoUrl: window.logoUrl,
      mpCustomLogo: window.custom_logo_url,
    }
  },
  computed: {
    venueInfo() {
      return this.$store.state.venueInfo;
    },
    strings () {
	  return this.$store.state.strings
    },
    sidebarState () {
      return this.$store.state.sidebarState
    },
    lang() {
      let lang = this.$store.state.selectedLang;
      if(lang == 'en'){
        lang = '';
      } else {
        lang = '/' + lang;
      }
      return lang;
    },
    userName() {
      return this.$store.state.userInfo.username
    },
    isLoggedIn() {
      if(this.$store.state.userInfo)
        return true
      else 
        return false
    },
    isAmadeus() {
      return true
      return window.location.hostname === 'vsm.amadeus-hospitality.com'
    }
  },
  components: {
    MPSearchbar,
    MPLanguage
  },
  methods: {
    openSidebar: function() {
      if (!(this.$store.state.sidebarState)) {
        this.$store.commit('setSidebar', true);
      } else {
        this.$store.commit('setSidebar', false);
      }
    }
  },
}
</script>

<style scoped>
.top-bar__brand {
  display: flex;
  justify-content: center;
  align-items: center;
}
#hamburger-icon {
  top: -3px;
}
</style>

